import apiClient from './api';

const subscriptionService = {
    // Get all packages
    getPackages: async () => {
        const response = await apiClient.get('/subscription/packages');
        return response.data; // { success: true, data: [...] }
    },

    // Get current subscription
    getCurrentSubscription: async () => {
        const response = await apiClient.get('/subscription/current');
        return response.data; // { success: true, data: { ... } }
    },

    // Buy package
    buyPackage: async (packageId, promoCode = '', paymentMethod = 'WALLET') => {
        const response = await apiClient.post('/subscription/buy', { packageId, promoCode, paymentMethod });
        return response.data;
    },

    // Validate Promo Code
    validatePromo: async (packageId, promoCode) => {
        const response = await apiClient.post('/subscription/validate-promo', { packageId, promoCode });
        return response.data;
    }
};

export default subscriptionService;
